/* unplugin-vue-components disabled */import { render } from "./c-title.vue?vue&type=template&id=cbb52236&scoped=true"
import script from "./c-title.vue?vue&type=script&lang=js"
export * from "./c-title.vue?vue&type=script&lang=js"

import "./c-title.vue?vue&type=style&index=0&id=cbb52236&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbb52236"]])

export default __exports__